var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-page-loader kt-page-loader--logo"},[_c('img',{attrs:{"alt":"Logo","src":_vm.logo}}),_c('b-spinner',{staticClass:"mt-3",staticStyle:{"color":"#FF961D"},attrs:{"label":"Spinning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }